
<template>
    <div>
        {{currentPage}} / {{pageCount}}
        <pdf
            :src="src"
            :page="page"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
        ></pdf>
        <va-button @click="mais_pagina()">Mais</va-button> 
        <va-button color="info" @click="menos_pagina()">Menos</va-button> 

        <iframe src="https://docs.google.com/gview?url=http://remote.url.tld/path/to/document.doc&embedded=true"></iframe>
    </div>
</template>

<script>
var loadingTask = 'https://cdn.rawgit.com/mozilla/pdf.js/c6e8ca86/test/pdfs/freeculture.pdf';

import pdf from 'vue-pdf'

export default {
    components: {
        pdf
    },
    data() {
        return {
            src: loadingTask,
            currentPage: 0,
            pageCount: 0,
            page:1
        }
    },
    methods:{
      mais_pagina(){
        this.page++
      },
      menos_pagina(){
        this.page--
      }

    }
}

</script>